/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountNote,
  CreateAccountNoteRequest,
  GetAccountNotesParams,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get account notes for an account.
 */
export const getAccountNotes = (
  billingAccountId: number,
  params?: GetAccountNotesParams,
  options?: SecondParameter<typeof backofficeRequest<AccountNote[]>>,
) => {
  return backofficeRequest<AccountNote[]>(
    {
      url: `/api/v1/accounts/${billingAccountId}/notes`,
      method: "GET",
      params,
    },
    options,
  )
}
/**
 * @summary Create a note for an account.
 */
export const createAccountNote = (
  billingAccountId: number,
  createAccountNoteRequest: CreateAccountNoteRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/api/v1/accounts/${billingAccountId}/notes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAccountNoteRequest,
    },
    options,
  )
}
export type GetAccountNotesResult = NonNullable<
  Awaited<ReturnType<typeof getAccountNotes>>
>
export type CreateAccountNoteResult = NonNullable<
  Awaited<ReturnType<typeof createAccountNote>>
>
